import apiClient from '@/lib/apiClient';

export type BlogStatus = 'DRAFT' | 'PUBLISHED' | 'REJECTED' | 'ARCHIVED';

export interface BlogPost {
  id: number;
  locale: 'ar' | 'en';
  slug: string;
  category?: string | null;
  title: string;
  excerpt?: string | null;
  content: string;
  image?: string | null;
  metaTitle?: string | null;
  metaDescription?: string | null;
  keywords?: string | null;
  status: BlogStatus;
  generatedByAi: boolean;
  source?: string | null;
  publishDate?: string | null;
  publishedAt?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface BlogPageResponse {
  content: BlogPost[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export type BlogPostInput = Partial<BlogPost> & Pick<BlogPost, 'locale' | 'title' | 'content'>;

export const blogApi = {
  list: async (params: { locale?: string; status?: BlogStatus | ''; search?: string; page?: number; size?: number }): Promise<BlogPageResponse> => {
    const res = await apiClient.get('/admin/blog/posts', { params });
    return res.data?.data;
  },
  get: async (id: number): Promise<BlogPost> => {
    const res = await apiClient.get(`/admin/blog/posts/${id}`);
    return res.data?.data;
  },
  create: async (body: BlogPostInput): Promise<BlogPost> => {
    const res = await apiClient.post('/admin/blog/posts', body);
    return res.data?.data;
  },
  update: async (id: number, body: BlogPostInput): Promise<BlogPost> => {
    const res = await apiClient.put(`/admin/blog/posts/${id}`, body);
    return res.data?.data;
  },
  publish: async (id: number): Promise<BlogPost> => {
    const res = await apiClient.post(`/admin/blog/posts/${id}/publish`);
    return res.data?.data;
  },
  reject: async (id: number): Promise<BlogPost> => {
    const res = await apiClient.post(`/admin/blog/posts/${id}/reject`);
    return res.data?.data;
  },
  generateDrafts: async (body: { locale?: string; count?: number; topicHint?: string }): Promise<BlogPost[]> => {
    const res = await apiClient.post('/admin/blog/posts/generate-drafts', body, { timeout: 120000 });
    return res.data?.data || [];
  },
};

